import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Sound = (props: IconProps) => (
  <Icon width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.2595 61.707C47.7595 61.707 61.2595 48.207 61.2595 31.707C61.2595 15.207 47.7595 1.70703 31.2595 1.70703C14.7595 1.70703 1.25952 15.207 1.25952 31.707C1.25952 48.207 14.7595 61.707 31.2595 61.707Z"
      fill="white"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M40.4861 22.8759V37.0019C40.4861 39.477 38.4735 41.4897 35.9983 41.4897C33.5356 41.4897 31.5105 39.477 31.5105 37.0019C31.5105 34.5392 33.5356 32.5266 35.9983 32.5266C37.0484 32.5266 37.9859 32.8891 38.7485 33.4891V26.0511L27.2352 29.3263V39.4145C27.2352 41.8897 25.21 43.9023 22.7473 43.9023C20.2721 43.9023 18.2595 41.8897 18.2595 39.4145C18.2595 36.9519 20.2721 34.9392 22.7473 34.9392C23.7849 34.9392 24.7225 35.3017 25.485 35.8893V24.8385C25.485 23.0009 26.5976 21.5758 28.3603 21.1008L35.5858 19.1256C37.0484 18.7256 38.2859 18.8631 39.161 19.5381C40.0486 20.2007 40.4861 21.3258 40.4861 22.8759Z" />
  </Icon>
);
